import { render, staticRenderFns } from "./MasterCardContactNumberDetailsContainer.vue?vue&type=template&id=3b5b2ed0&scoped=true"
import script from "./MasterCardContactNumberDetailsContainer.vue?vue&type=script&lang=js"
export * from "./MasterCardContactNumberDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b2ed0",
  null
  
)

export default component.exports